<template>
  <div class="annotate" v-if='internalComments.length > 0'>
    <el-card  hit shadow class="box-card">
      <div slot="header" class="clearfix">
        <el-switch v-model="showComments" style="float: right; padding: 3px 0" active-text="Έμφάνιση" inactive-text="Αποκρυψη"></el-switch>
        <span>Εσωτερικά σχόλια</span>
      </div>
      <div class="text item" v-if='showComments'>
        <el-table :data="internalComments" style="width: 100%">
          <el-table-column label="Ονοματεπώνυμο" width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ρόλος" width="140">
            <template slot-scope="scope">
              <span>{{ translate(scope.row.role) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ημερομηνία" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.dateCompleted ? scope.row.dateCompleted.substring(0, 16) : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Σχόλιο" align="center">
            <template slot-scope="scope">
              <el-popover trigger="click" placement="top-start"
                title= "Σχόλιο: "
                width="400">
                <span slot="reference" style="color: blue">{{ scope.row.internalComment.substring(0, 20) }}...</span>
                <span >{{ scope.row.internalComment }}</span>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import dictionaryForMenu from '../../store/dictionaryForMenu'

export default {
  components: {
    dictionaryForMenu
  },
  data () {
    return {
      showComments: true
    }
  },
  methods: {
    // Use a translate method to translate the queues to the greek names Προέλεγχος, Ειδικός...
    translate (term) {
      return dictionaryForMenu[term] ? dictionaryForMenu[term] : ''
    }
  },
  computed: {
    ...mapState([
      'internalComments'
    ])
  }
}
</script>

<style lang="scss" scoped>
// .annotate {
//   border-radius: 10px;
//   border: 2px solid #e04a56;
// }
</style>



// WEBPACK FOOTER //
// src/components/common/internalComments.vue